import React from "react";

import { TickIcon as Tick } from "@packages/ds";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { PLANS } from "Constants/plans";

import * as S from "./styles";

const DEFAULTS = [
  ["project.plan.includes.user", { value: 1 }],
  ["project.plan.includes.envs", { value: 3 }],
  ["project.plan.includes.storage", { value: 5 }]
];

const PlanInfo = ({ plan }) => {
  const intl = useIntl();

  const details = PLANS.find(elt => elt.name.includes(plan));
  const defaults = DEFAULTS.map(elt => {
    if (!details?.defaults) return elt;
    const override = details?.defaults.find(obj => obj[0] === elt[0]);
    if (override) {
      return override;
    }
    return elt;
  });

  return details ? (
    <S.Wrapper>
      <S.FeatureList>
        {defaults.map((elt, i) => (
          <S.FeatureItem key={`default-${i}`}>
            <Tick color="var(--mode-vector-primary-default)" />{" "}
            <span>
              {intl.formatMessage(
                {
                  id: elt[0]
                },
                {
                  ...elt[1],
                  b: txt => <span>{txt}</span>
                }
              )}
            </span>
          </S.FeatureItem>
        ))}
      </S.FeatureList>

      {details?.includes && (
        <S.FeatureList>
          {details.includes.map((elt, i) => (
            <S.FeatureItem key={`include-${i}`}>
              <Tick color="var(--mode-vector-primary-default)" />{" "}
              <span>
                {intl.formatMessage(
                  {
                    id: elt[0]
                  },
                  {
                    ...elt[1],
                    b: txt => <span>{txt}</span>
                  }
                )}
              </span>
            </S.FeatureItem>
          ))}
        </S.FeatureList>
      )}
    </S.Wrapper>
  ) : //Only show information for plans that we have cached
  null;
};

PlanInfo.propTypes = {
  plan: PropTypes.string
};

export default PlanInfo;
